/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {RescheduleAppointmentRequest} from '@cash-web/protos/squareup/cash/local/client/v1/local_appointment.pb'
import {RescheduleAppointmentResponse} from '@cash-web/protos/squareup/cash/local/client/v1/local_appointment.pb'


export const rescheduleAppointment = (request: RescheduleAppointmentRequest, options?: CashRequestOptions) => post<RescheduleAppointmentRequest, RescheduleAppointmentResponse>("/2.0/cash/reschedule-appointment", request, {...options, rejectOnError: true })